<h2>upp-grid</h2>
<p class="demo-description">Product catalog using <code>upp-grid</code> with view mode, scale, and empty state.</p>

<div class="demo-controls">
    <ion-button size="small" (click)="toggleViewMode()">
        <ion-icon [name]="viewMode === 'GRID' ? 'grid-outline' : 'list-outline'" slot="start"></ion-icon>
        {{ viewMode }}
    </ion-button>
    <ion-button size="small" (click)="toggleSize()">
        <ion-icon [name]="gridSize === 'SMALL' ? 'expand-outline' : 'contract-outline'" slot="start"></ion-icon>
        {{ gridSize }}
    </ion-button>
    <ion-button size="small" [color]="showItems ? 'medium' : 'success'" (click)="toggleItems()">
        <ion-icon [name]="showItems ? 'eye-off-outline' : 'eye-outline'" slot="start"></ion-icon>
        {{ showItems ? 'Hide Products' : 'Show Products' }}
    </ion-button>
</div>

<div class="demo-section demo-section--scrollable">
    <div class="grid-container">
        <upp-grid name="DEMO_CATALOG" [size]="gridSize">
            <upp-grid-empty>
                <div class="empty-state">
                    <ion-icon name="storefront-outline" class="empty-icon"></ion-icon>
                    <p>No products found</p>
                </div>
            </upp-grid-empty>

            <ng-container *ngIf="showItems">
                <upp-grid-item *ngFor="let p of products">
                    <upp-thumb
                        [title]="p.name"
                        [color]="p.color"
                        [icon]="p.icon"
                        [detail]="p.price"
                        [foot]="p.stock">
                    </upp-thumb>
                </upp-grid-item>
            </ng-container>
        </upp-grid>
    </div>
</div>
